const GA_MEASUREMENT_ID = (process.env.REACT_APP_GA_ID || 'G-VQX61JBYK7').trim();
const disableFlag = GA_MEASUREMENT_ID ? `ga-disable-${GA_MEASUREMENT_ID}` : '';

export function setAnalyticsConsent(allowed: boolean) {
  if (typeof window === 'undefined' || !GA_MEASUREMENT_ID) return;
  (window as any)[disableFlag] = !allowed;
  if (!allowed) return;

  const win = window as any;
  win.dataLayer = win.dataLayer || [];
  if (!win.gtag) {
    win.gtag = function gtag() {
      win.dataLayer.push(arguments);
    };
  }

  const existing = document.querySelector(`script[data-gtag="${GA_MEASUREMENT_ID}"]`);
  if (!existing) {
    const script = document.createElement('script');
    script.async = true;
    script.src = `https://www.googletagmanager.com/gtag/js?id=${GA_MEASUREMENT_ID}`;
    script.dataset.gtag = GA_MEASUREMENT_ID;
    document.head.appendChild(script);
  }

  win.gtag('js', new Date());
  win.gtag('config', GA_MEASUREMENT_ID, { anonymize_ip: true });
}
